// https://inertiajs.com/events
// Don't use `navigate` event to clear toasts, as it can make the first toast on a new page disappear too quickly.
import { push } from 'notivue';

export function registerInertiaEventHandler(inertiaRouter) {
  // Inertia will emit 'invalid' event when it receives non-JSON response
  // for example HTML page, when server error (500) or not found (404) occurs in development environment.
  inertiaRouter.on('invalid', (event) => {
    const statusCode = event.detail?.response?.status || 500;
    const data = event.detail?.response?.data;
    const errorMessage = data?.message ?? 'Server error occurred.';
    const errorType = data?.type;

    if (!errorType) {
      return;
    }

    event.preventDefault();
    const notification = { title: errorType, message: errorMessage };

    // Check with ERROR_TYPE_DB constant defined in /bootstrap/inertia/InertiaExceptionHandler.php
    if (statusCode >= 500 || errorType == 'Database Error' || errorType == 'Application Error') {
      push.error(notification);
    } else if (statusCode >= 400) {
      push.warning(notification);
    }
  });
}
